import React from "react";
import { Phone, AlertTriangle } from "lucide-react";
import { SITE } from "../lib/site";

/**
 * Bandeau d'appel d'urgence rouge — visible mobile + desktop.
 * Persistant (non-fermable), sticky en bas du viewport sur mobile.
 */
export default function UrgencyBar() {
  return (
    <section
      data-testid="urgency-bar"
      className="bg-[#EF4444] text-white"
      role="region"
      aria-label="Urgence électrique"
    >
      <div className="container-x py-4 lg:py-5 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-3 text-center sm:text-left">
        <div className="flex items-center gap-3">
          <span className="emergency-dot shrink-0" />
          <AlertTriangle className="w-5 h-5 shrink-0" strokeWidth={2} />
          <p className="font-semibold text-base sm:text-lg">
            Urgence électrique ? Appelez maintenant
          </p>
        </div>
        <a
          href={`tel:${SITE.phoneTel}`}
          data-testid="urgency-call-btn"
          className="inline-flex items-center gap-2 bg-white text-[#EF4444] hover:bg-yellow-50 transition-colors px-5 py-3 font-bold text-base rounded-sm shrink-0"
        >
          <Phone className="w-5 h-5" strokeWidth={2.5} />
          {SITE.phoneDisplay}
        </a>
      </div>
    </section>
  );
}
